/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "f953f585051eb7f7b2c5f31767ba6a8057eeb125";
